import svgIcons from "../../../assets/svg/svgIcons";
import PagewideMessageDisplay from "../../../components/pagewideMessageDisplay";
import { APP_CONFIG } from "../../../constants/constants";
import { useChatContext } from "../contexts/chat.context";
import SMSConversation from "./smsConversation";

const SMSMainColumn = () => {
  const { selectedSMSUser, dataSMSConversation, isFetchingSMSConversation } =
    useChatContext();

  return (
    <>
      {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
        <pre className="absolute flex flex-col text-[10px] bottom-0 left-0 z-10">
          Conversations:
          <br />
          <span className="bg-accent-blue-pale w-64 h-48 overflow-auto">
            {JSON.stringify(dataSMSConversation, null, 2)}
          </span>
        </pre>
      )}
      {isFetchingSMSConversation ? (
        <div className="col-span-8 h-[calc(100vh-160px)] flex items-center justify-center">
          <img
            src={svgIcons.LoadingAnimation}
            alt="loading"
            className="w-12 h-12 m-auto"
          />
        </div>
      ) : !!selectedSMSUser ? (
        <SMSConversation
          key={`sms-conversation-${selectedSMSUser}`}
          wrapperClass="col-span-8 h-[calc(100vh-160px)]"
        />
      ) : (
        <PagewideMessageDisplay
          title="Select a user"
          description="Please select a user to start sending messages"
        />
      )}
    </>
  );
};
export default SMSMainColumn;
